/* CUSTOM START — Purpose: Slideshow-Videos vollständig abspielen, bevor der Slider weiterschaltet | Date: 2026-10-14 | Dependency: sections/slideshow.liquid, sections/slideshow-hero.liquid, assets/theme.js */
(() => {
  if (window.customSlideshowVideoTimingLoaded) return;
  window.customSlideshowVideoTimingLoaded = true;

  const selector = 'slideshow-element[data-video-timing], slideshow-hero[data-video-timing]';

  function visibleVideoMedia(slide) {
    const media = slide?.querySelectorAll('video-media');
    if (!media?.length) return null;

    if (window.theme?.utils?.visibleMedia) {
      return window.theme.utils.visibleMedia(media);
    }

    return Array.from(media).find((item) => window.getComputedStyle(item).display !== 'none') || null;
  }

  function initialize(slideshow) {
    if (slideshow.dataset.videoTimingInitialized === 'true') return;
    slideshow.dataset.videoTimingInitialized = 'true';

    let userPaused = false;

    const currentSlide = () => slideshow.items?.[slideshow.selectedIndex] || slideshow.children[slideshow.selectedIndex];

    const advanceAfterVideo = (slide, media) => {
      if (!slideshow.hasAttribute('autoplay') || userPaused || currentSlide() !== slide) return;
      if (visibleVideoMedia(slide) !== media) return;
      slideshow.slider?.next();
    };

    const updateTiming = () => {
      if (!slideshow.slider || !slideshow.hasAttribute('autoplay')) return;

      const slide = currentSlide();
      if (slide?.dataset.type === 'video') {
        slideshow.slider.pausePlayer();

        const media = visibleVideoMedia(slide);
        if (!media) return;

        const restartNativeVideo = () => {
          const video = media.querySelector('video');
          if (!video) return;
          video.currentTime = 0;
          video.play().catch(() => {});
        };

        if (media.hasAttribute('playing')) {
          restartNativeVideo();
        } else {
          media.addEventListener('video:play', restartNativeVideo, { once: true });
          media.play();
        }
      } else if (!userPaused) {
        slideshow.slider.playPlayer();
      }
    };

    slideshow.addEventListener('slider:change', updateTiming);
    slideshow.addEventListener('slider:pause', () => {
      userPaused = true;
    });
    slideshow.addEventListener('slider:play', () => {
      userPaused = false;
      updateTiming();
    });

    // Das Theme vereinheitlicht das natürliche Ende von Shopify-, YouTube- und Vimeo-Videos.
    slideshow.addEventListener('video:ended', (event) => {
      const media = event.target;
      if (!(media instanceof HTMLElement)) return;

      const slide = media.closest('[data-type="video"]');
      advanceAfterVideo(slide, media);
    });

    const waitForSlider = () => {
      if (!slideshow.isConnected) return;
      if (slideshow.slider) {
        updateTiming();
      } else {
        window.requestAnimationFrame(waitForSlider);
      }
    };

    waitForSlider();
  }

  function initializeAll(container = document) {
    if (container.matches?.(selector)) initialize(container);
    container.querySelectorAll?.(selector).forEach(initialize);
  }

  Promise.all([
    customElements.whenDefined('slideshow-element'),
    customElements.whenDefined('slideshow-hero')
  ]).then(() => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
/* CUSTOM END */
